// src/config/moduleRegistry.ts
//
// Espelho do registry de módulos do backend (api/src/modules/registry.ts) para o
// gating de feature flags no frontend (multi-tenant US4): esconder no menu e barrar
// no router as rotas de módulos que o tenant NÃO tem ativos (tenantStore.enabledModules).
//
// Só mapeia módulos de feature. Rotas CORE (/, /users, /permissions, navegação,
// dashboard, notificações, /admin/tenants) NÃO têm slug → nunca são gated.

export interface FrontModule {
    slug: string;
    /** Nome de exibição — espelha o `nome` do registry do backend (api/src/modules/registry.ts). */
    nome: string;
    /** Prefixos de rota do frontend que pertencem ao módulo. */
    prefixes: string[];
}

export const FRONT_MODULES: readonly FrontModule[] = [
    { slug: 'bookings', nome: 'Reservas', prefixes: ['/bookings'] },
    { slug: 'courses', nome: 'Cursos / E-learning', prefixes: ['/courses'] },
    { slug: 'kanban', nome: 'Kanban', prefixes: ['/kanban'] },
    { slug: 'notes', nome: 'Notas', prefixes: ['/notes'] },
    { slug: 'timeline', nome: 'Timeline', prefixes: ['/timeline'] },
    { slug: 'marketing', nome: 'Marketing / IA', prefixes: ['/marketing'] },
    { slug: 'loja-escola', nome: 'Loja Escola', prefixes: ['/loja-escola'] },
    { slug: 'catalog-products', nome: 'Portfólio de Produtos', prefixes: ['/produtos'] },
    { slug: 'itam', nome: 'Gestão de Ativos (ITAM)', prefixes: ['/itam', '/assets', '/ativos', '/licenses', '/domains', '/itsm'] },
    { slug: 'policies', nome: 'Políticas', prefixes: ['/policies', '/politicas'] },
    { slug: 'separacao', nome: 'ACD · Separação', prefixes: ['/logistica/separacao'] },
    { slug: 'saldo-estoque', nome: 'Logística · Saldos', prefixes: ['/logistica/saldos'] },
    { slug: 'reembolso', nome: 'Reembolso', prefixes: ['/reembolso'] },
    // `/compras` cobre os relatórios do módulo (Relatório de Compras). Tem de
    // espelhar api/src/modules/registry.ts: sem o prefixo aqui, o menu e o
    // guard tratam a tela como CORE e a abrem em tenant sem o módulo — para o
    // backend responder 404 e o usuário ver uma tela quebrada.
    { slug: 'purchase-orders', nome: 'Pedidos de Compra', prefixes: ['/pedidos-compra', '/compras'] },
    { slug: 'cartao-corporativo', nome: 'Cartão Corporativo', prefixes: ['/cartao-corporativo'] },
    { slug: 'service-desk', nome: 'Service Desk', prefixes: ['/desk', '/ticket'] },
    { slug: 'wiki', nome: 'Wiki', prefixes: ['/wiki'] },
    { slug: 'indoor-tv', nome: 'Indoor TV', prefixes: ['/indoor-tv'] },
    { slug: 'assistente', nome: 'Assistente (Chat Corporativo)', prefixes: ['/assistente'] },
    { slug: 'inovacao', nome: 'Inovação', prefixes: ['/inovacao'] },
    { slug: 'relatorio-municipal', nome: 'Relatório Municipal', prefixes: ['/relatorio-municipal'] },
    { slug: 'auditoria-comodato', nome: 'Auditoria de Comodato', prefixes: ['/auditoria-comodato'] },
    { slug: 'eventos', nome: 'Eventos', prefixes: ['/eventos'] },
    { slug: 'controladoria', nome: 'Controladoria', prefixes: ['/controladoria'] },
    { slug: 'cotacao-fretes', nome: 'Cotação de Fretes', prefixes: ['/cotacao-fretes', '/logistica/transportadora'] },
    { slug: 'plataformas', nome: 'Plataformas', prefixes: ['/plataformas'] },
    { slug: 'gateway', nome: 'Gateway de Pagamento', prefixes: ['/gateway'] },
    { slug: 'pco', nome: 'PCO / Faturas', prefixes: ['/resources'] },
    { slug: 'dashboards', nome: 'Dashboards', prefixes: ['/dashboards'] },
    { slug: 'controle-acesso', nome: 'Controle de Acesso', prefixes: ['/seguranca/controle-acesso'] },
    // CRM | CS: app próprio em domínio próprio; /crm/cs* é a chave de permissão.
    { slug: 'crm-cs', nome: 'CRM | CS (Customer Success)', prefixes: ['/crm/cs'] },
];

/** Slug do módulo ao qual a rota pertence, ou null se for CORE (sem gate). */
export function moduleSlugForPath(path: string): string | null {
    const p = (path || '').split('?')[0];
    for (const m of FRONT_MODULES) {
        if (m.prefixes.some((pre) => p === pre || p.startsWith(pre + '/'))) {
            return m.slug;
        }
    }
    return null;
}
